var _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAlphaDevs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 40,
    viewBox: "0 0 207 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.59247,
    width: 33.2851,
    height: 33.2851,
    rx: 4.99276,
    transform: "rotate(13.1855 7.59247 0)",
    fill: "url(#paint0_linear_723_10)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5619 19.0923L25.3983 19.9911L16.7414 28.1517L18.4385 20.9077L14.6021 20.0089L23.259 11.8483L21.5619 19.0923Z",
    fill: "#F3F3F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.218384,
    y: 7.32092,
    width: 33.2851,
    height: 33.2851,
    rx: 4.99276,
    transform: "rotate(-12.3207 0.218384 7.32092)",
    fill: "url(#paint1_linear_723_10)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0474 18.5372L24.897 17.6964L20.5978 28.7894L19.0102 21.5206L15.1607 22.3614L19.4598 11.2685L21.0474 18.5372Z",
    fill: "#F3F3F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.32898,
    y: 3.32849,
    width: 33.2851,
    height: 33.2851,
    rx: 4.99276,
    fill: "url(#paint2_linear_723_10)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.011 13.6508L13.2523 25.4095V27.9711H14.9319V26.2494L26.6907 14.4906V11.9711H25.011V13.6508ZM26.7747 17.0101C26.7284 17.0101 26.6909 17.0479 26.6907 17.0941V25.3744C26.6907 25.3966 26.682 25.4182 26.6663 25.434L25.8753 26.225C25.8596 26.2406 25.8379 26.2494 25.8157 26.2494H17.5355C17.4893 26.2496 17.4515 26.2871 17.4515 26.3334V27.8451C17.4515 27.8913 17.4893 27.9289 17.5355 27.9291H26.6556C26.6778 27.9291 26.6994 27.9203 26.7151 27.9047L28.346 26.2738C28.3617 26.2581 28.3704 26.2365 28.3704 26.2142V17.0941C28.3702 17.0479 28.3327 17.0101 28.2864 17.0101H26.7747ZM13.2874 11.9711C13.2652 11.9711 13.2436 11.9799 13.2278 11.9955L11.597 13.6263C11.5813 13.6421 11.5726 13.6637 11.5726 13.6859V22.806C11.5728 22.8523 11.6103 22.89 11.6566 22.89H13.1683C13.2145 22.89 13.2521 22.8523 13.2523 22.806V14.5258C13.2523 14.5035 13.261 14.4819 13.2767 14.4662L14.0677 13.6752C14.0834 13.6596 14.1051 13.6508 14.1273 13.6508H22.4075C22.4537 13.6505 22.4915 13.613 22.4915 13.5668V12.0551C22.4915 12.0088 22.4537 11.9713 22.4075 11.9711H13.2874Z",
    fill: "#FAF4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6743 25.3568H53.2083L51.9254 29H48.8723L55.2608 11.1431H58.6474L65.0359 29H61.9571L60.6743 25.3568ZM59.8533 22.9707L56.9541 14.6837L54.0293 22.9707H59.8533ZM70.7384 26.6396H76.7677V29H67.8136V11.1688H70.7384V26.6396ZM91.6827 16.4796C91.6827 17.3862 91.4689 18.2414 91.0413 19.0453C90.6137 19.8492 89.9296 20.5077 88.9888 21.0208C88.0481 21.5169 86.8422 21.7649 85.3713 21.7649H82.1385V29H79.2137V11.1688H85.3713C86.7396 11.1688 87.8941 11.4082 88.8349 11.8871C89.7927 12.3489 90.5026 12.9818 90.9644 13.7857C91.4433 14.5896 91.6827 15.4876 91.6827 16.4796ZM85.3713 19.3788C86.483 19.3788 87.3126 19.1308 87.8599 18.6348C88.4073 18.1217 88.6809 17.4033 88.6809 16.4796C88.6809 14.5297 87.5777 13.5548 85.3713 13.5548H82.1385V19.3788H85.3713ZM108.712 11.1688V29H105.787V21.2004H97.3971V29H94.4723V11.1688H97.3971V18.8144H105.787V11.1688H108.712ZM123.312 25.3568H115.846L114.563 29H111.51L117.899 11.1431H121.285L127.674 29H124.595L123.312 25.3568ZM122.491 22.9707L119.592 14.6837L116.667 22.9707H122.491Z",
    fill: "#0D0D0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.94 11.1688C144.839 11.1688 146.498 11.5365 147.918 12.272C149.354 12.9904 150.458 14.0337 151.227 15.4021C152.014 16.7533 152.407 18.3355 152.407 20.1485C152.407 21.9616 152.014 23.5352 151.227 24.8693C150.458 26.2034 149.354 27.2297 147.918 27.9481C146.498 28.6494 144.839 29 142.94 29H137.116V11.1688H142.94ZM142.94 26.6139C145.027 26.6139 146.626 26.0495 147.738 24.9206C148.85 23.7917 149.406 22.201 149.406 20.1485C149.406 18.0789 148.85 16.4625 147.738 15.2994C146.626 14.1363 145.027 13.5548 142.94 13.5548H140.041V26.6139H142.94ZM158.231 13.5291V18.7631H164.389V21.1491H158.231V26.6139H165.158V29H155.306V11.1431H165.158V13.5291H158.231ZM184.129 11.1688L177.433 29H174.046L167.324 11.1688H170.454L175.739 25.9982L181.05 11.1688H184.129ZM187.037 11.1688H190.218L187.524 17.275H185.472L187.037 11.1688ZM198.664 29.1796C197.467 29.1796 196.389 28.9743 195.431 28.5638C194.473 28.1362 193.721 27.5376 193.174 26.7679C192.626 25.9982 192.353 25.1002 192.353 24.074H195.483C195.551 24.8437 195.85 25.4765 196.381 25.9725C196.928 26.4686 197.689 26.7166 198.664 26.7166C199.673 26.7166 200.46 26.4771 201.024 25.9982C201.589 25.5022 201.871 24.8693 201.871 24.0996C201.871 23.501 201.691 23.0135 201.332 22.6372C200.99 22.2609 200.554 21.9701 200.024 21.7649C199.511 21.5596 198.792 21.3373 197.869 21.0978C196.706 20.7899 195.756 20.4821 195.021 20.1742C194.302 19.8492 193.687 19.3532 193.174 18.6861C192.66 18.019 192.404 17.1296 192.404 16.0178C192.404 14.9916 192.66 14.0936 193.174 13.3239C193.687 12.5542 194.405 11.9641 195.329 11.5536C196.252 11.1431 197.321 10.9378 198.536 10.9378C200.263 10.9378 201.674 11.374 202.769 12.2463C203.881 13.1015 204.497 14.2817 204.616 15.7869H201.384C201.332 15.137 201.024 14.5811 200.46 14.1192C199.896 13.6574 199.151 13.4265 198.228 13.4265C197.39 13.4265 196.706 13.6403 196.175 14.0679C195.645 14.4955 195.38 15.1113 195.38 15.9152C195.38 16.4625 195.542 16.9158 195.867 17.275C196.21 17.6171 196.637 17.8907 197.15 18.096C197.663 18.3013 198.365 18.5236 199.254 18.7631C200.434 19.088 201.392 19.413 202.128 19.738C202.88 20.063 203.513 20.5676 204.026 21.2517C204.556 21.9188 204.822 22.8168 204.822 23.9457C204.822 24.8522 204.574 25.7074 204.078 26.5113C203.599 27.3152 202.889 27.9652 201.948 28.4612C201.024 28.9401 199.93 29.1796 198.664 29.1796Z",
    fill: "#B670EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_723_10",
    x1: 7.59247,
    y1: 0,
    x2: 41.435,
    y2: 0.576838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_723_10",
    x1: 0.218384,
    y1: 7.32092,
    x2: 34.0609,
    y2: 7.89776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_723_10",
    x1: 3.32898,
    y1: 3.32849,
    x2: 37.1715,
    y2: 3.90533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlphaDevs);
export default __webpack_public_path__ + "static/media/LogoAlphaDevs.5bccb199202773f2348db15dba50d44e.svg";
export { ForwardRef as ReactComponent };